import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export const GlobalContext = createContext<{
  showNetworkError: () => void;
  showServerError: () => void;
  navigate: (val: string) => void;
  startWebcam: () => Promise<MediaStream | null>;
  startScreenCapture: () => Promise<MediaStream | null>;
  handleScrollUp: () => void;
  openTest: boolean;
  setOpenTest: Dispatch<SetStateAction<boolean>>;
}>({
  showNetworkError: () => {},
  showServerError: () => {},
  navigate: () => {},
  startWebcam: () => Promise.resolve(null),
  startScreenCapture: () => Promise.resolve(null),
  handleScrollUp: () => {},
  openTest: false,
  setOpenTest: () => {},
});

export const useGlobalContext = () => useContext(GlobalContext);
